import { isManualChargeDetailEntity } from "domain/entity/ManualCharge/ManualChargeDetailEntity";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import { vatPaymentReferenceDateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { NonOpsConstant, nonOpsDtlRequiredFieldList } from "presentation/constant/NonOps/NonOpsConstant";
import { useNonOpsDetailVM } from "presentation/hook/NonOps/useNonOpsDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useNonOpsDetailTracked } from "presentation/store/NonOps/NonOpsDetailProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const NonOpsDetailFormPanel = () => {
    const [nonOpsDetailState] = useNonOpsDetailTracked();
    const nonOpsDetailVM = useNonOpsDetailVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState(false);
    const { isAdd, isEditable, isRead, isSaveClicked, allFormState, allowAutoRefresh, currentSelectedData, isAdjustmentRead } = nonOpsDetailState.viewState;
    const currentManChgDtl = currentSelectedData;
    const countryCode = getDefaultBuConfig("REACT_APP_DEFAULT_COUNTRY")
    const [isAmtReadOnly, setIsAmtReadOnly] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;
    const dynamicOptions = nonOpsDetailState.dynamicOptions;

    const HDR_CONST = NonOpsConstant.Header;
    const DTL_CONST = NonOpsConstant.Detail;

    useEffect(() => {
        setIsAmtReadOnly(isRead || (currentManChgDtl.individualChargeAmount !== null && (currentManChgDtl.individualChargeAmount !== null
            && currentManChgDtl.individualChargeAmount.toString() !== ''))
            || (currentManChgDtl.chargeQty !== null && currentManChgDtl.chargeQty.toString() !== ''));
    }, [currentManChgDtl.chargeAmount, currentManChgDtl.chargeQty, currentManChgDtl.individualChargeAmount, isRead]);

    const handleCancelClick = () => {
        nonOpsDetailVM.onCancelDetail();
    }

    const handleSaveClick = useCallback(() => {

        if (currentManChgDtl.vatPercentage && (currentManChgDtl.vatPercentage < 0.00 || currentManChgDtl.vatPercentage > 100.00)) {
            messageBarVM.showError("Tax % should be range from 0 to 100.");
            return;
        }
        if (currentManChgDtl.vatDays && (currentManChgDtl.vatDays < 0.00 || currentManChgDtl.vatDays > 999.00)) {
            messageBarVM.showError("Tax Payment Term should be range from 0 to 999.");
            return;
        }

        setIsLoading(true);
        let checkVat = false;
        if (currentManChgDtl.vatArticleStatementCode || currentManChgDtl.vatArticleStatementCode || currentManChgDtl.vatDays
            || currentManChgDtl.paymentReferenceDate || currentManChgDtl.vatOneOffTaxCode || currentManChgDtl.taxCostCenterCode
            || currentManChgDtl.taxRevenueAccountCode || currentManChgDtl.taxProductServiceCode || currentManChgDtl.taxSalesChannelCode
            || currentManChgDtl.taxProjectCode || currentManChgDtl.taxSpareCode || currentManChgDtl.taxIntercompanyCode) {
            checkVat = true;
        }
        nonOpsDetailVM.onSaveClicked();
        nonOpsDetailVM.onSaveDetail(checkVat, currentManChgDtl, isAdd, operatingUnit).then((res) => {
            if (res && isManualChargeDetailEntity(res)) {
                setIsLoading(false);
            } else {
                setIsLoading(false);
                if (res && res["mandatoryCheckFail"]) {
                    messageBarVM.showError(res["mandatoryCheckFail"]?.toString());
                }
            }
        }).catch((error) => {
            setIsLoading(false);
            messageBarVM.showError(error.message);
        })

    }, [currentManChgDtl, isAdd, nonOpsDetailVM, messageBarVM, operatingUnit])

    useEffect(() => {
        const refereshTaxInfo = async () => {
            nonOpsDetailVM.onRefreshDefaultTarCode(currentManChgDtl.vatOneOffTaxCode, dynamicOptions.taxTariffTypeDropdownOptions,
                dynamicOptions.allTariffCodeeDropdownOptions, dynamicOptions.articleStatementCodeDropdownOptions
            );
        }
        if (allowAutoRefresh) {
            refereshTaxInfo();
        }

    }, [allowAutoRefresh, currentManChgDtl.vatOneOffTaxCode, dynamicOptions.allTariffCodeeDropdownOptions, dynamicOptions.articleStatementCodeDropdownOptions, dynamicOptions.taxTariffCodeDropdownOptions, dynamicOptions.taxTariffTypeDropdownOptions, nonOpsDetailState.dynamicOptions.articleStatementCodeDropdownOptions, nonOpsDetailState.dynamicOptions.taxTariffCodeDropdownOptions, nonOpsDetailState.dynamicOptions.taxTariffTypeDropdownOptions, nonOpsDetailVM])

    const onNumberFieldChange = useCallback((event: any, fieldName: string, fieldValue: any) => {
        nonOpsDetailVM.onFieldChange(fieldName, fieldValue);
        if (fieldName === "chargeAmount") {
            nonOpsDetailVM.onFieldChange("chargeQty", "");
        }
    }, [nonOpsDetailVM]);

    const memoState = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.dtlState || ''}
                fieldValue={currentManChgDtl?.dtlState}
                fieldLabel={HDR_CONST.STATE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlState'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.STATE, allFormState, currentManChgDtl?.dtlState, isSaveClicked])


    const memoAmt = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }} >
            <NumberInputComponent
                label={DTL_CONST.AMT}
                maxLength={13}
                fieldName={"chargeAmount"}
                value={currentManChgDtl?.chargeAmount ?? ''}
                errorMessage={allFormState?.chargeAmount}
                disabled={isAmtReadOnly}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isAmtReadOnly}
                readOnlyValue={currentManChgDtl?.chargeAmount?.toString() || ''}
                fieldValue={currentManChgDtl?.chargeAmount?.toString()}
                fieldLabel={DTL_CONST.AMT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeAmount'}
                maxLength={200}
                isShowMissingError={false}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue);
                    nonOpsDetailVM.onFieldChange("chargeQty", "", fFullValue);
                }}  /> */}
        </div>
        , [DTL_CONST.AMT, allFormState?.chargeAmount, currentManChgDtl?.chargeAmount, isAmtReadOnly, onNumberFieldChange])

    const memoDesc1 = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '520px', width: "65%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.dtlDesc1 || ''}
                fieldValue={currentManChgDtl?.dtlDesc1}
                fieldLabel={DTL_CONST.DTL_DESC1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlDesc1'}
                isShowMissingError={false}
                maxLength={270}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.DTL_DESC1, allFormState, currentManChgDtl?.dtlDesc1, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoDesc2 = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '520px', width: "65%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={false}
                readOnlyValue={currentManChgDtl?.dtlDesc2 || ''}
                fieldValue={currentManChgDtl?.dtlDesc2}
                fieldLabel={DTL_CONST.DTL_DESC2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlDesc2'}
                maxLength={270}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.DTL_DESC2, allFormState, currentManChgDtl?.dtlDesc2, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoRevAcCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.revenueAccountCode || ''}
                fieldValue={currentManChgDtl?.revenueAccountCode}
                fieldLabel={DTL_CONST.REV_AC_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueAccountCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.REV_AC_CODE, allFormState, currentManChgDtl?.revenueAccountCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoCostCenterCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.costCenterCode || ''}
                fieldValue={currentManChgDtl?.costCenterCode}
                fieldLabel={DTL_CONST.COST_CENTER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'costCenterCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.COST_CENTER_CODE, allFormState, currentManChgDtl?.costCenterCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoProdServCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.productServiceCode || ''}
                fieldValue={currentManChgDtl?.productServiceCode}
                fieldLabel={DTL_CONST.PROD_SER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'productServiceCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.PROD_SER_CODE, allFormState, currentManChgDtl?.productServiceCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoSalesChannelCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.salesChannelCode || ''}
                fieldValue={currentManChgDtl?.salesChannelCode}
                fieldLabel={DTL_CONST.SALES_CHANNEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'salesChannelCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.SALES_CHANNEL_CODE, allFormState, currentManChgDtl?.salesChannelCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoCountryCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.countryCode || countryCode}
                fieldValue={currentManChgDtl?.countryCode}
                fieldLabel={DTL_CONST.COUNTRY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'countryCode'}
                maxLength={25}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.COUNTRY_CODE, allFormState, countryCode, currentManChgDtl?.countryCode, isSaveClicked])

    const memoProjCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.projectCode || ''}
                fieldValue={currentManChgDtl?.projectCode}
                fieldLabel={DTL_CONST.PROJECT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'projectCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.PROJECT_CODE, allFormState, currentManChgDtl?.projectCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoSpareCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.spareCode || ''}
                fieldValue={currentManChgDtl?.spareCode}
                fieldLabel={DTL_CONST.SPARE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'spareCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.SPARE_CODE, allFormState, currentManChgDtl?.spareCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoRevCmpCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.revenueCompanyCode || ''}
                fieldValue={currentManChgDtl?.revenueCompanyCode}
                fieldLabel={HDR_CONST.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueCompanyCode'}
                maxLength={25}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.COMPANY_CODE, allFormState, currentManChgDtl?.revenueCompanyCode, isSaveClicked])

    const memoInterCmpCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.intercompanyCode ?? ''}
                fieldValue={currentManChgDtl?.intercompanyCode ?? ''}
                fieldLabel={DTL_CONST.INTER_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'intercompanyCode'}
                options={nonOpsDetailState.dynamicOptions.interCmpCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.INTER_COMPANY_CODE, allFormState, currentManChgDtl?.intercompanyCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailState.dynamicOptions.interCmpCodeDropdownOptions, nonOpsDetailVM])



    const memoTaxCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatOneOffTaxCode ?? ''}
                fieldValue={currentManChgDtl?.vatOneOffTaxCode ?? ''}
                fieldLabel={DTL_CONST.TAX_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatOneOffTaxCode'}
                options={nonOpsDetailState.dynamicOptions.taxCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_CODE, allFormState, currentManChgDtl?.vatOneOffTaxCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailState.dynamicOptions.taxCodeDropdownOptions, nonOpsDetailVM])

    const memoAdjType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.adjType || ''}
                fieldValue={currentManChgDtl?.adjType}
                fieldLabel={DTL_CONST.ADJ_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'adjType'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.ADJ_TYPE, allFormState, currentManChgDtl?.adjType, isSaveClicked])

    const memoRefNoAdjFrom = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.adjRefNo || ''}
                fieldValue={currentManChgDtl?.adjRefNo}
                fieldLabel={DTL_CONST.REF_NO_ADJ_FROM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'adjRefNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.REF_NO_ADJ_FROM, allFormState, currentManChgDtl?.adjRefNo, isSaveClicked])


    // Tax %
    const memoOneOffRatePercentage = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={DTL_CONST.TAX_PERCENTAGE}
                optional={true}
                maxLength={6}
                fieldName={"vatPercentage"}
                value={currentManChgDtl?.vatPercentage ?? ''}
                errorMessage={allFormState?.vatPercentage ?? ''}
                disabled={isRead || isAdjustmentRead}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatPercentage?.toString() || ''}
                fieldValue={currentManChgDtl?.vatPercentage?.toString()}
                fieldLabel={DTL_CONST.TAX_PERCENTAGE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatPercentage'}
                isShowMissingError={false}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [DTL_CONST.TAX_PERCENTAGE, allFormState, currentManChgDtl?.vatPercentage, isAdjustmentRead, isRead, onNumberFieldChange])

    const memoTaxRevAcCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxRevenueAccountCode || ''}
                fieldValue={currentManChgDtl?.taxRevenueAccountCode}
                fieldLabel={DTL_CONST.TAX_REV_AC_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxRevenueAccountCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_REV_AC_CODE, allFormState, currentManChgDtl?.taxRevenueAccountCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxCostCenterCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxCostCenterCode || ''}
                fieldValue={currentManChgDtl?.taxCostCenterCode}
                fieldLabel={DTL_CONST.TAX_COST_CENTER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxCostCenterCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_COST_CENTER_CODE, allFormState, currentManChgDtl?.taxCostCenterCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxProdServCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxProductServiceCode || ''}
                fieldValue={currentManChgDtl?.taxProductServiceCode}
                fieldLabel={DTL_CONST.TAX_PROD_SER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxProductServiceCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_PROD_SER_CODE, allFormState, currentManChgDtl?.taxProductServiceCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxSalesChannelCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxSalesChannelCode || ''}
                fieldValue={currentManChgDtl?.taxSalesChannelCode}
                fieldLabel={DTL_CONST.TAX_SALES_CHANNEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxSalesChannelCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_SALES_CHANNEL_CODE, allFormState, currentManChgDtl?.taxSalesChannelCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxCountryCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxCountryCode || countryCode}
                fieldValue={currentManChgDtl?.taxCountryCode}
                fieldLabel={DTL_CONST.TAX_COUNTRY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxCountryCode'}
                maxLength={25}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.TAX_COUNTRY_CODE, allFormState, countryCode, currentManChgDtl?.taxCountryCode, isSaveClicked])

    const memoTaxProjCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxProjectCode || ''}
                fieldValue={currentManChgDtl?.taxProjectCode}
                fieldLabel={DTL_CONST.TAX_PROJECT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxProjectCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_PROJECT_CODE, allFormState, currentManChgDtl?.taxProjectCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxSpareCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxSpareCode || ''}
                fieldValue={currentManChgDtl?.taxSpareCode}
                fieldLabel={DTL_CONST.TAX_SPARE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxSpareCode'}
                isShowMissingError={false}
                maxLength={25}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_SPARE_CODE, allFormState, currentManChgDtl?.taxSpareCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxRevCmpCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxRevenueCompanyCode || ''}
                fieldValue={currentManChgDtl?.taxRevenueCompanyCode}
                fieldLabel={DTL_CONST.TAX_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'taxRevenueCompanyCode'}
                maxLength={25}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.TAX_COMPANY_CODE, allFormState, currentManChgDtl?.taxRevenueCompanyCode, isSaveClicked])

    const memoTaxInterCmpCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.taxIntercompanyCode ?? ''}
                fieldValue={currentManChgDtl?.taxIntercompanyCode ?? ''}
                fieldLabel={DTL_CONST.TAX_INTER_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'taxIntercompanyCode'}
                options={nonOpsDetailState.dynamicOptions.interCmpCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_INTER_COMPANY_CODE, allFormState, currentManChgDtl?.taxIntercompanyCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailState.dynamicOptions.interCmpCodeDropdownOptions, nonOpsDetailVM])

    const memoTxType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatTransactionType || ''}
                fieldValue={currentManChgDtl?.vatTransactionType}
                fieldLabel={DTL_CONST.TX_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatTransactionType'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.TX_TYPE, allFormState, currentManChgDtl?.vatTransactionType, isSaveClicked])

    const memoInvNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.invoiceNo || ''}
                fieldValue={currentManChgDtl?.invoiceNo}
                fieldLabel={HDR_CONST.INV_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'invoiceNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.INV_NO, allFormState, currentManChgDtl?.invoiceNo, isSaveClicked])

    const memoCreditNoteNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.creditNo || ''}
                fieldValue={currentManChgDtl?.creditNo}
                fieldLabel={HDR_CONST.CREDIT_NOTE_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'creditNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.CREDIT_NOTE_NO, allFormState, currentManChgDtl?.creditNo, isSaveClicked])

    const memoDraftInvoiceNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.draftInvoiceNo || ''}
                fieldValue={currentManChgDtl?.draftInvoiceNo}
                fieldLabel={HDR_CONST.DRAFT_INV_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'draftInvoiceNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.DRAFT_INV_NO, allFormState, currentManChgDtl?.draftInvoiceNo, isSaveClicked])

    const memoDraftCreditNoteNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.draftCreditNo || ''}
                fieldValue={currentManChgDtl?.draftCreditNo}
                fieldLabel={HDR_CONST.DRAFT_CREDIT_NOTE_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'draftCreditNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [HDR_CONST.DRAFT_CREDIT_NOTE_NO, allFormState, currentManChgDtl?.draftCreditNo, isSaveClicked])

    const memoExMsg = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.exceptionMsg || ''}
                fieldValue={currentManChgDtl?.exceptionMsg}
                fieldLabel={DTL_CONST.EX_MSG}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'exceptionMsg'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.EX_MSG, allFormState, currentManChgDtl?.exceptionMsg, isSaveClicked])



    const memoArticleStatementCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatArticleStatementCode ?? ''}
                fieldValue={currentManChgDtl?.vatArticleStatementCode ?? ''}
                fieldLabel={DTL_CONST.ARTICLE_STATEMENT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatArticleStatementCode'}
                options={nonOpsDetailState.dynamicOptions.articleStatementCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.ARTICLE_STATEMENT_CODE, allFormState, currentManChgDtl?.vatArticleStatementCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailState.dynamicOptions.articleStatementCodeDropdownOptions, nonOpsDetailVM])

    const memoArticleStatement = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatArticleStatement || ''}
                fieldValue={currentManChgDtl?.vatArticleStatement}
                fieldLabel={DTL_CONST.ARTICLE_STATEMENT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatArticleStatement'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [DTL_CONST.ARTICLE_STATEMENT, allFormState, currentManChgDtl?.vatArticleStatement, isSaveClicked])


    const memoVatDays = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={String(currentManChgDtl?.vatDays || '')}
                fieldValue={String(currentManChgDtl?.vatDays || '')}
                fieldLabel={DTL_CONST.TAX_PAYMENT_TERM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDays'}
                isShowMissingError={false}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_PAYMENT_TERM, allFormState, currentManChgDtl?.vatDays, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoVatRefDate = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.paymentReferenceDate ?? ''}
                fieldValue={currentManChgDtl?.paymentReferenceDate ?? ''}
                fieldLabel={DTL_CONST.TAX_PAYMENT_REF_TERM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'paymentReferenceDate'}
                isShowMissingError={false}
                options={vatPaymentReferenceDateDropdownOption}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_PAYMENT_REF_TERM, allFormState, currentManChgDtl?.paymentReferenceDate, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxDesc1 = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatDesc1 || ''}
                fieldValue={currentManChgDtl?.vatDesc1}
                fieldLabel={DTL_CONST.TAX_DTL_DESC1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDesc1'}
                maxLength={90}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_DTL_DESC1, allFormState, currentManChgDtl?.vatDesc1, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoTaxDesc2 = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={true}
                readOnlyValue={currentManChgDtl?.vatDesc2 || ''}
                fieldValue={currentManChgDtl?.vatDesc2}
                fieldLabel={DTL_CONST.TAX_DTL_DESC2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDesc2'}
                maxLength={90}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.TAX_DTL_DESC2, allFormState, currentManChgDtl?.vatDesc2, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailVM])

    const memoCurrency = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '240px', maxWidth: '240px', width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isAdjustmentRead}
                isShowOptional={false}
                readOnlyValue={currentManChgDtl?.currencyCode ?? ''}
                fieldValue={currentManChgDtl?.currencyCode ?? ''}
                fieldLabel={DTL_CONST.CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'currencyCode'}
                options={nonOpsDetailState.dynamicOptions.currencyDropdownOptions}
                maxLength={60}
                requiredFieldList={nonOpsDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DTL_CONST.CURRENCY, allFormState, currentManChgDtl?.currencyCode, isAdjustmentRead, isRead, isSaveClicked, nonOpsDetailState.dynamicOptions.currencyDropdownOptions, nonOpsDetailVM])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{'Detail'}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoState}
                            {memoAmt}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoDesc1}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoDesc2}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoRevAcCode}
                            {memoCostCenterCode}
                            {memoProdServCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoSalesChannelCode}
                            {memoCountryCode}
                            {memoProjCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoSpareCode}
                            {memoRevCmpCode}
                            {memoInterCmpCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTaxCode}
                            {memoAdjType}
                            {memoOneOffRatePercentage}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTaxRevAcCode}
                            {memoTaxCostCenterCode}
                            {memoTaxProdServCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTaxSalesChannelCode}
                            {memoTaxCountryCode}
                            {memoTaxProjCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTaxSpareCode}
                            {memoTaxRevCmpCode}
                            {memoTaxInterCmpCode}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTxType}
                            {memoVatDays}
                            {memoVatRefDate}
                        </CriteriaItemContainer>


                        <CriteriaItemContainer>
                            {memoArticleStatementCode}
                            {memoArticleStatement}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoCurrency}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTaxDesc1}
                            {memoTaxDesc2}
                            {memoInvNo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCreditNoteNo}
                            {memoDraftInvoiceNo}
                            {memoDraftCreditNoteNo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoRefNoAdjFrom}
                            {memoExMsg}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={isRead ? 'Close' : 'Cancel'} size={'Small'} theme={'Secondary'} onClick={handleCancelClick} />
                        {!isRead && <HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                    </>
                }
            </div>

        </div>
    )
}